import { Field } from '@chakra-ui/react'
import type { ChangeEvent, ReactNode } from 'react'

export type FieldApi<T> = {
  state: {
    value: T
    meta: {
      errors: Array<{ message?: string } | undefined>
    }
  }
  handleChange: (value: T) => void
  handleBlur: () => void
}

export type FieldRowProps = {
  field: FieldApi<unknown>
  label: string
  helperText?: string
  errorText?: string
  children: ReactNode
}

export function FieldRow({
  field,
  label,
  helperText,
  errorText,
  children,
}: Readonly<FieldRowProps>) {
  const { errors } = field.state.meta
  const fieldError = errors[0]
  const shownError = fieldError ? String(fieldError.message ?? '') : errorText
  return (
    <Field.Root invalid={errors.length > 0 || errorText !== undefined}>
      <Field.Label>{label}</Field.Label>
      {children}
      {helperText ? <Field.HelperText>{helperText}</Field.HelperText> : null}
      {shownError === undefined ? null : (
        <Field.ErrorText>{shownError}</Field.ErrorText>
      )}
    </Field.Root>
  )
}

export function handleNumberChange(field: FieldApi<number>) {
  return (event: ChangeEvent<HTMLInputElement>) => {
    field.handleChange(
      event.target.value === ''
        ? (Number.NaN as unknown as number)
        : Number(event.target.value),
    )
  }
}

export function handleStringChange(field: FieldApi<string>) {
  return (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    field.handleChange(event.target.value)
  }
}

export function numberInputValue(v: number): string | number {
  return Number.isNaN(v) ? '' : v
}
